import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import '../../../src/styles/Login.css';
import { FaChevronDown } from 'react-icons/fa';
import { Accordion } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { userService } from '../../_services';
import { Link } from 'react-router-dom';
import { de } from 'date-fns/locale';
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers'
import { Redirect, Route } from 'react-router-dom';
import { FaChevronUp } from 'react-icons/fa';
import { Collapse } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';
import ReCAPTCHA from "react-google-recaptcha";
import HCaptcha from '@hcaptcha/react-hcaptcha';
let Loading = true, captchaverified = false, useragent = navigator.userAgent;
export class Login extends Component {
    displayName = Login.name
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            username: '',
            password: '',
            errors: {},
            loginhome: false, ShowUp1: false,
            redirecttocart: false
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);
        this.ReactCaptcha = this.ReactCaptcha.bind(this);
        this.onVerifyCaptcha = this.onVerifyCaptcha.bind(this);
    }

    onVerifyCaptcha(token) {
        console.log("Verified: " + token);
        if (token !== null || token !== "") {
            captchaverified = true;
        }
    }

    ReactCaptcha(value) {
        // console.log("Captcha value:", value);
        if (value !== null || value !== "") {
            captchaverified = true;
        }
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // Trigger the button element with a click
            document.getElementById("LoginButtonClick").click();

        }
    }

    handleSelect(e) {
        window.scrollTo(0, 0);

    }


    handleChange(event) {

        let setvalue = '';
        setvalue = event.target.value
        var self = this;
        self.setState({ [event.target.id]: setvalue });
    }

    componentDidMount() {
        //localStorage.removeItem('user');
        //localStorage.clear();
        if (localStorage.getItem('user') !== null) {
            var head = document.getElementsByTagName('head')[0];
            window['NTPT_PGEXTRA'] = 'User_id=' + localStorage.getItem('salesForceID') + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            head.appendChild(script);

            var msg = {
                ArticleTitle: window['NTPT_PGEXTRA']
            }
            var Logurl = 'Product/LogData';
            appService.submit(Logurl, msg).then(function (data) {

            });
        }
        Loading = true;

        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
        //window.location.reload(true);
    }

    timeoutPromise(ms, promise) {
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                reject(new Error("promise timeout"))
            }, ms);
            promise.then(
                (res) => {
                    clearTimeout(timeoutId);
                    resolve(res);
                },
                (err) => {
                    clearTimeout(timeoutId);
                    reject(err);
                }
            );
        })
    }

    handleLogin(e) {
        var self = this;
        e.preventDefault();
        if (self.handleValidation()) {

            var logindetails = {
                id: self.state.username,
                password: self.state.password
            }

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify(logindetails)
            };
            let user = self.state.username;

            this.timeoutPromise(120000, fetch(config.apiUrl + '/User/Login', requestOptions)
                .then(this.handleResponse, this.handleError)
                .then(function (response) {

                    if (response.validationMsg == 'success') {
                        localStorage.setItem('userId', response.id),
                        localStorage.setItem('company', response.company);
                        localStorage.setItem('firstName', response.firstName);
                        localStorage.setItem('lastName', response.lastName);
                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('usersubscription', response.userSubscription);
                        localStorage.setItem('salesForceID', response.customerID);
                        localStorage.setItem('version', '1.0');
                        localStorage.setItem('setupTime', new Date().getTime());
                        if (localStorage.getItem('user') !== null && localStorage.getItem('redirecttocart') == 'true') {
                            localStorage.removeItem('redirecttocart');
                            self.setState({ redirecttocart: true });
                            self.setState({ loginhome: false });
                        }
                        else {
                            //localStorage.removeItem('redirecttocart');
                            self.setState({ loginhome: true });
                        }
                    }
                    else {


                        let errors = {};
                        let formIsValid = true;
                        if (response.validationMsg == "* This username is not active.  Please contact technical support for additional help.") {
                            errors["username"] = response.validationMsg;
                        }
                        else {
                            errors["password"] = response.validationMsg;
                        }
                        self.setState({ errors: errors });
                        if (!formIsValid) {
                            return false;
                        }
                    }
                }));
        }
        //localStorage.setItem('user', JSON.stringify("gatestuser01@wolterskluwer.com"));
        //var self = this;        
        //userService.loginTemp('User/loginTemp')
        //    .then(function (data) {
        //    })
    }

    handleValidation() {

        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!self.state.username) {
            formIsValid = false;
            errors["username"] = "* Required field";
        }
        if (!self.state.password) {
            formIsValid = false;
            errors["password"] = "* Required field";
        }

        if (captchaverified == false) {
            formIsValid = false;
            errors["captch"] = "* Required field";
        }

        self.setState({ errors: errors });
        if (!formIsValid) {
            return false;
        }
        return true;
    }

    handleResponse(response) {
        return new Promise((resolve, reject) => {
            if (response.ok) {
                // return json if it was returned in the response
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    response.json().then(json => resolve(json));
                } else {
                    resolve();
                }
            } else {
                // return error message from response body
                response.text().then(text => reject(text));
            }
        });
    }

    handleError(error) {
        return Promise.reject(error && error.message);
    }
    render() {
        ////console.log(window['LastURL']);
        //let version = window.Configs.version;
        //console.log(window.Configs.version);
        //console.log(version);
        if (this.state.redirecttocart) {
            return <Redirect to={"ShoppingCart"} />
        }
        else if (this.state.loginhome) {
            return <Redirect to={window['LastURL'] !== undefined && window['LastURL'] != '' && window['LastURL'] !== '/' && !window['LastURL'].toLowerCase().includes('resetpassword')? window['LastURL'] : "/LoginHome"} />
        }

        const meta = {
            title: "Kluwer Law Online - Login",
            canonical: window.location.href,
        }
        const isMfaLinkVisible = false;
        const localAuthBaseUrl = window.location.hostname === 'localhost' ? 'http://localhost:6020' : '';
        const authBaseUrl = config.authBaseUrl || localAuthBaseUrl;
        const openAthensLoginUrl = authBaseUrl + "/account/login";
        const mfaLoginUrl = authBaseUrl + "/account/AzureLogin";
        //console.log(Loading);
        if (Loading == true) {
            var head = document.getElementsByTagName('head')[0];
            const Wayfinderscript = document.createElement("script");
            Wayfinderscript.src = "/Wayfinder.js";
            Wayfinderscript.async = true;
            head.appendChild(Wayfinderscript);
        }

        return (
            <DocumentMeta {...meta}>
                <div className="col-12">
                    <div className="White">
                    </div>
                    <div>
                        <p style={{ textAlign: 'center' }}>
                            Should you experience access problems, please contact <Link to="/Feedback">Technical Support</Link>.
                                </p>
                    </div>
                    <div className="White">
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <div className="col-lg-12 BGGrey Loginhomepadding LoginHeight logintop" >
                                <p className="LoginText franziskafont"> Login directly</p> <br></br>
                                <p className="LoginText LoginSetright"><input className="form-control BookBody" type="text" placeholder="Username" id="username" value={this.state.username} title="Username" onChange={this.handleChange} />
                                    <span className="error">{this.state.errors["username"]}</span>
                                </p>
                                <p className="LoginText LoginSetright"><input type="password" className="form-control BookBody" type="password" placeholder="Password" id="password" value={this.state.password} title="password" onChange={this.handleChange} onKeyDown={this._handleKeyDown} />
                                    <span className="error">{this.state.errors["password"]}</span></p>
                                <br></br>
                                <div className="LoginText LoginSetright">                                   

                                    <HCaptcha title="CAPTCHA secure login feature respone" sitekey="f94f2e81-bacc-4b03-a3bb-8a04ec65f5f4" onVerify={this.onVerifyCaptcha} />

                                    <span className="error">{this.state.errors["captch"]}</span>
                                </div>
                                <br></br>
                                <p className="LoginText LoginSetright"><a href={window['LastURL'] !== undefined && window['LastURL'] != '' && window['LastURL'] !== '/' ? window['LastURL'] : "/LoginHome"} id="LoginButtonClick" className="btn btn-info next" role="button" onClick={this.handleLogin}>Login</a>
                                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        window.location.href == "https://test.kluwerlawonline.com/Login" ?

                                            <a href="https://kluwerlawonline.com">Refer URL</a>
                                            :
                                            null
                                    }
                                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;<a href="/ForgotPassword" class="LinkClass" style={{ float: 'right', paddingTop: '2.5%' }}>Forgot password</a></p>

                            </div>
                            {/*<p className="LoginText"><a href="/LoginHome" className="btn btn-info next" role="button" >Login</a></p>

                        
                            <a href="https://login.intelliconnect.inta.cch.com/as/authorization.oauth2?client_id=TestOAuthClient&pfidpadapterid=GACompositeIDP&scope=openid+profile+email&response_type=code&redirect_uri=http://aiew1albnklo1-1935864601.eu-west-1.elb.amazonaws.com/LoginHome"
                                color="primary"
                                className="btn btn-info next Setwdth"
                            >
                                Login using One ID
                           </a>
                        */}
                            <br /><br />
                            <span style={{ display: 'none' }}>
                                <Link to={{ pathname: "/UserRegistration" }}>
                                    <div className="btn btn-info next" role="button">User Registration</div></Link>
                            </span>
                        </div>
                        <div className="col-4">
                            <div className="col-lg-12 BGGrey divleft LoginHeight logintop">
                                <p className="LoginText  franziskafont"> Login via OpenAthens/Institution
                                <br></br><br></br>
                                    <a href={openAthensLoginUrl} className="LinkClass" onClick={this.handleSelect}>Go to OpenAthens & Shibboleth</a>
                                    {isMfaLinkVisible ?
                                        <span>
                                            <br></br><br></br>
                                            <a href={mfaLoginUrl} className="LinkClass" onClick={this.handleSelect}>Sign in with Microsoft MFA</a>
                                        </span>
                                        : null
                                    }</p>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <p className="logina">Contact our <Link to="/ContactSales" className="LinkClass">sales team </Link>to find out about Kluwer Law Online.</p>
                    </div >
                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </DocumentMeta >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx